// tslint:disable: no-any
import ActionType from "../../types/ActionType"
import OrganizationSurveysActions from "../actions/organizationSurveys"
import { OrganizationSurveyType } from "../../types/OrganizationSurveyType"

export interface OrganizationSurveysStore {
  errorMessage: string
  loadingOrganizationSurveys: boolean
  loadingOrganizationSurvey: boolean
  organizationSurveys: OrganizationSurveyType[]
  organizationSurvey: OrganizationSurveyType | null
}

const INITIAL_STATE: OrganizationSurveysStore = {
  errorMessage: "",
  loadingOrganizationSurveys: false,
  loadingOrganizationSurvey: false,
  organizationSurveys: [],
  organizationSurvey: null,
}

export default (state = INITIAL_STATE, action: ActionType) => {
  switch (action.type) {
    case OrganizationSurveysActions.FETCH_ORGANIZATION_SURVEYS_TRIGGER: {
      return {
        ...state,
        loadingOrganizationSurveys: true,
        errorMessage: "",
      }
    }

    case OrganizationSurveysActions.FETCH_ORGANIZATION_SURVEYS_SUCCESS: {
      return {
        ...state,
        loadingOrganizationSurveys: false,
        organizationSurveys: action.payload.organizationSurveys || [],
        errorMessage: "",
      }
    }

    case OrganizationSurveysActions.FETCH_ORGANIZATION_SURVEYS_ERROR: {
      return {
        ...state,
        loadingOrganizationSurveys: false,
        errorMessage: action.payload,
      }
    }

    case OrganizationSurveysActions.FETCH_ORGANIZATION_SURVEY_TRIGGER: {
      return {
        ...state,
        loadingOrganizationSurvey: true,
        errorMessage: "",
      }
    }

    case OrganizationSurveysActions.FETCH_ORGANIZATION_SURVEY_SUCCESS: {
      return {
        ...state,
        loadingOrganizationSurvey: false,
        organizationSurvey: action.payload.organizationSurvey,
        errorMessage: "",
      }
    }

    case OrganizationSurveysActions.FETCH_ORGANIZATION_SURVEY_ERROR: {
      return {
        ...state,
        loadingOrganizationSurvey: false,
        errorMessage: action.payload,
      }
    }

    case OrganizationSurveysActions.CREATE_ORGANIZATION_SURVEY_TRIGGER: {
      return {
        ...state,
        loadingOrganizationSurvey: true,
        errorMessage: "",
      }
    }

    case OrganizationSurveysActions.CREATE_ORGANIZATION_SURVEY_SUCCESS: {
      return {
        ...state,
        loadingOrganizationSurvey: false,
        organizationSurvey: action.payload.organizationSurvey,
        organizationSurveys: [...state.organizationSurveys, action.payload.organizationSurvey],
        errorMessage: "",
      }
    }

    case OrganizationSurveysActions.CREATE_ORGANIZATION_SURVEY_ERROR: {
      return {
        ...state,
        loadingOrganizationSurvey: false,
        errorMessage: action.payload,
      }
    }

    case OrganizationSurveysActions.UPDATE_ORGANIZATION_SURVEY_TRIGGER: {
      return {
        ...state,
        loadingOrganizationSurvey: true,
        errorMessage: "",
      }
    }

    case OrganizationSurveysActions.UPDATE_ORGANIZATION_SURVEY_SUCCESS: {
      const updatedSurvey = action.payload.organizationSurvey
      return {
        ...state,
        loadingOrganizationSurvey: false,
        organizationSurvey: updatedSurvey,
        organizationSurveys: state.organizationSurveys.map((survey) => (survey.id === updatedSurvey.id ? updatedSurvey : survey)),
        errorMessage: "",
      }
    }

    case OrganizationSurveysActions.UPDATE_ORGANIZATION_SURVEY_ERROR: {
      return {
        ...state,
        loadingOrganizationSurvey: false,
        errorMessage: action.payload,
      }
    }

    case OrganizationSurveysActions.DELETE_ORGANIZATION_SURVEY_TRIGGER: {
      return {
        ...state,
        loadingOrganizationSurvey: true,
        errorMessage: "",
      }
    }

    case OrganizationSurveysActions.DELETE_ORGANIZATION_SURVEY_SUCCESS: {
      const deletedId = action.payload.id
      return {
        ...state,
        loadingOrganizationSurvey: false,
        organizationSurveys: state.organizationSurveys.filter((survey) => survey.id !== deletedId),
        organizationSurvey: state.organizationSurvey && state.organizationSurvey.id === deletedId ? null : state.organizationSurvey,
        errorMessage: "",
      }
    }

    case OrganizationSurveysActions.DELETE_ORGANIZATION_SURVEY_ERROR: {
      return {
        ...state,
        loadingOrganizationSurvey: false,
        errorMessage: action.payload,
      }
    }

    case OrganizationSurveysActions.CLEAR_ORGANIZATION_SURVEYS: {
      return INITIAL_STATE
    }

    default:
      return state
  }
}
